/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/grading';

type Props = {
  total: number;
  graded: number;
};

const styles = {
  container: () => css`
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    margin-bottom: var(--cds-spacing-200);
  `,
  progressBarContainer: () => css`
    width: 100%;
    height: 12px;
    background-color: var(--cds-color-neutral-stroke-primary-weak);
    border-radius: 20px;
    margin-right: var(--cds-spacing-200);
    overflow: hidden;
  `,
  progressBarInner: (widthPercent: number) => css`
    width: ${widthPercent}%;
    height: 12px;
    background-color: var(--cds-color-feedback-success);
    border-radius: 20px;
    transition: width 0.05s;
  `,
};

const GradedProgressBar: React.FC<Props> = ({ total, graded }) => {
  if (total === 0) {
    return null;
  }
  return (
    <div css={styles.container}>
      <span css={styles.progressBarContainer}>
        <div css={styles.progressBarInner(Math.ceil((graded / total) * 100))} />
      </span>
      <span>
        <Typography2 component="p" variant="bodyPrimary">
          <Typography2 variant="subtitleMedium" component="span">
            {graded}
          </Typography2>
          <span>{`/${total} ${_t('graded')}`}</span>
        </Typography2>
      </span>
    </div>
  );
};

export default GradedProgressBar;
